import { resourceState, resourceMutations, resourceGetters } from '@/store/utils/resource';
import { CONVERSATIONS } from '@/store/entities/schema_types';
import { contactConversationsClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters('conversations'),
  actions: {
    async load(ctx, { contactId, query = {} }) {
      try {
        const response = await client.list(contactId, query);

        const { data } = response.data;

        const id = await ctx.dispatch(
          'entities/persistEntities',
          { type: CONVERSATIONS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdByParent',
          parentId: contactId,
          id,
        });

        return Promise.resolve(true);
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },

    async store(ctx, { contactId, formData }) {
      try {
        const response = await client.store(contactId, mapKeysToSnakeCase(formData, true));

        const { data } = response.data;

        const conversationId = await ctx.dispatch(
          'entities/persistEntities',
          { type: CONVERSATIONS, data },
          { root: true }
        );

        return Promise.resolve({ conversationId });
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
